import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllSiteUsersAndIdentitiesSpace,AllSiteUsersAndIdentitiesSpaceDispatchProps,AllSiteUsersAndIdentitiesSpaceOwnProps, AllSiteUsersAndIdentitiesSpaceStateProps } from './AllSiteUsersAndIdentitiesSpace';

const mapStateToProps: MapStateToProps<AllSiteUsersAndIdentitiesSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,

  doesTheServerHaveMoreThanOneSite: SessionServerSelectors.doesTheServerHaveMoreThanOneSite(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersAndIdentitiesSpaceDispatchProps> = (dispatch) => bindActionCreators({
    requestSpaceContents,
    updateBreadcrumbs
  }, dispatch);

export const ConnectedAllSiteUsersAndIdentitiesSpace: React.ComponentClass<AllSiteUsersAndIdentitiesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersAndIdentitiesSpace);
